import React, { useEffect, useMemo, useState } from "react";
import people from "../../../assets/svg/people.svg";
import { useBusinessContext } from "../../../context/business";
import moment from "moment";

export default function BookingHeader({ dataisvisible, currentStepIndex }) {
  const {
    businessData: { team, businessData },
  } = useBusinessContext();

  const hasBookingPolicy =
    businessData?.policy && businessData?.policy !== "<p><br></p>";

  function getInitials(name) {
    if (!name) return "";

    const trimmed = name.trim();
    if (trimmed === "") return "";

    return trimmed.charAt(0).toUpperCase();
  }

  return (
    !!businessData && (
      <>
        {dataisvisible && (
          <div className="booking_header">
            <div className="booking_header_rapper flex">
              <div className="booking_header-business-info flex">
                {
                  businessData?.logo ? (
                    <span className="dp_rapper" data-is-visible={currentStepIndex === 1 ||
                  (
                    currentStepIndex === 2 &&
                    (
                        businessData?.show_team_members === false ||
                      team?.length === 1
                    )
                      )}>
                        <img
                          src={businessData.logo || people}
                          alt=""
                        data-normal={!businessData.logo}
                        loading="lazy"
                        decoding="async"
                      />
                    </span>
                  ) : (
                    <span
                        className="business-avatar dp_rapper" data-is-visible={currentStepIndex === 1 ||
                          (
                            currentStepIndex === 2 &&
                            (
                              businessData?.show_team_members === false ||
                              team?.length === 1
                            )
                          )}
                        data-initials={getInitials(businessData?.name)}
                      />
                    )
                }

                <div className="text_container">
                  <p className="title">{businessData.name}</p>
                  <p className="faint">
                    {businessData.location_type === "Physical Location" &&
                      !businessData.hide_business_address ? (
                      <>
                        {businessData.address}
                        {!!businessData.city && `, ${businessData.city}`}
                        {!!businessData.state && `, ${businessData.state}`}
                      </>
                    ) : businessData.location_type === "Physical Location" &&
                      businessData.hide_business_address ? (
                      "Address will be sent to you once booking is confirmed."
                    ) : (
                      ""
                    )}

                    {businessData.location_type !== "Physical Location" && (
                      <>{businessData.address}</>
                    )}
                  </p>

                  <div className="flex tag_container">
                    {businessData.priority_booking !== 0 && (
                      <p className="tag pink grt">
                        <svg
                          viewBox="0 0 15 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.3"
                            d="M7.5 14.25C10.9518 14.25 13.75 11.4518 13.75 8C13.75 4.54822 10.9518 1.75 7.5 1.75C4.04822 1.75 1.25 4.54822 1.25 8C1.25 11.4518 4.04822 14.25 7.5 14.25Z"
                            fill="#E40587"
                          />
                          <path
                            d="M8.125 7.375C8.125 7.02982 7.84518 6.75 7.5 6.75C7.15482 6.75 6.875 7.02982 6.875 7.375V10.5C6.875 10.8452 7.15482 11.125 7.5 11.125C7.84518 11.125 8.125 10.8452 8.125 10.5V7.375Z"
                            fill="#E40587"
                          />
                          <path
                            d="M8.125 5.5C8.125 5.15482 7.84518 4.875 7.5 4.875C7.15482 4.875 6.875 5.15482 6.875 5.5C6.875 5.84518 7.15482 6.125 7.5 6.125C7.84518 6.125 8.125 5.84518 8.125 5.5Z"
                            fill="#E40587"
                          />
                        </svg>
                        Priority Booking
                      </p>
                    )}
                    <div className="mbl">
                      <div className="booking-header-actions-mobile">
                        <OpenHours />
                        {hasBookingPolicy && <BookingPolicy />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="dsk">
                <div className="booking-header-actions">
                  <OpenHours />
                  {hasBookingPolicy && <BookingPolicy />}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  );
}

// Optional: Helper to format times nicely
const formatTime = (timeString) => {
  if (!timeString) return "";
  // Try to parse with moment
  const m = moment(timeString, ["hh:mm A", "HH:mm"]);
  return m.isValid() ? m.format("hh:mm A") : timeString;
};


function OpenHours() {
  const context = useBusinessContext();
  const businessData = context?.businessData?.businessData;

  // Define hooks at top level only
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (!e.target.closest(".open-hours-details")) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isOpen]);

  const shortToFull = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Thur: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };

  const days_name = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const normalizedOpeningWeekDays = useMemo(() => {
    if (!Array.isArray(businessData?.opening_week_days)) return [];
    return businessData.opening_week_days.map(
      (short) => shortToFull[short] || short
    );
  }, [businessData?.opening_week_days]);

  const openingHours = Array.isArray(businessData?.opening_hours)
    ? businessData.opening_hours
    : [];

  const safeFormatTime = (time) => {
    try {
      return time ? formatTime(time) : "—";
    } catch {
      return "—";
    }
  };

  // Now safe to return early, after all hooks
  if (!businessData) {
    return <div>Loading opening hours…</div>;
  }

  return (
    <details
      className="open-hours-details"
      open={isOpen}
      onToggle={(e) => setIsOpen(e.currentTarget.open)}
    >
      <summary>
        <div className="flex co_pink">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.16732 1.66666C7.51914 1.66666 5.90798 2.1554 4.53757 3.07108C3.16716 3.98675 2.09906 5.28824 1.46833 6.81096C0.837595 8.33368 0.672567 10.0092 0.994111 11.6257C1.31565 13.2423 2.10933 14.7271 3.27477 15.8925C4.4402 17.058 5.92506 17.8517 7.54157 18.1732C9.15808 18.4947 10.8336 18.3297 12.3563 17.699C13.8791 17.0683 15.1806 16.0002 16.0962 14.6297C17.0119 13.2593 17.5007 11.6482 17.5007 9.99999C17.5007 8.90564 17.2851 7.82201 16.8663 6.81096C16.4475 5.79991 15.8337 4.88125 15.0599 4.10743C14.2861 3.33361 13.3674 2.71978 12.3563 2.30099C11.3453 1.8822 10.2617 1.66666 9.16732 1.66666ZM9.16732 16.6667C7.84878 16.6667 6.55985 16.2757 5.46352 15.5431C4.36719 14.8106 3.51271 13.7694 3.00812 12.5512C2.50354 11.333 2.37152 9.99259 2.62875 8.69939C2.88599 7.40618 3.52093 6.2183 4.45328 5.28594C5.38563 4.35359 6.57351 3.71866 7.86672 3.46142C9.15993 3.20419 10.5004 3.33621 11.7185 3.84079C12.9367 4.34538 13.9779 5.19986 14.7105 6.29619C15.443 7.39252 15.834 8.68145 15.834 9.99999C15.834 11.7681 15.1316 13.4638 13.8814 14.714C12.6311 15.9643 10.9354 16.6667 9.16732 16.6667ZM9.16732 4.99999C8.94631 4.99999 8.73435 5.08779 8.57807 5.24407C8.42179 5.40035 8.33399 5.61231 8.33399 5.83332V9.51666L6.58399 10.525C6.42345 10.616 6.29765 10.7576 6.22631 10.9278C6.15496 11.098 6.14211 11.287 6.18978 11.4653C6.23744 11.6435 6.34291 11.8009 6.48967 11.9128C6.63642 12.0246 6.81614 12.0846 7.00065 12.0833C7.14663 12.0843 7.29032 12.047 7.41732 11.975L9.58399 10.725L9.65899 10.65L9.79232 10.5417C9.82491 10.5004 9.85285 10.4557 9.87566 10.4083C9.90281 10.3636 9.92516 10.3161 9.94232 10.2667C9.96499 10.2137 9.97905 10.1574 9.98399 10.1L10.0007 9.99999V5.83332C10.0007 5.61231 9.91286 5.40035 9.75658 5.24407C9.6003 5.08779 9.38834 4.99999 9.16732 4.99999Z"
              fill="#E40587"
            />
          </svg>
          View Opening Hours
        </div>
      </summary>

      <div className="card_container">
        <div className="card">
          {days_name.map((day) => {
            const isOpenDay = normalizedOpeningWeekDays.includes(day);
            const matchingHours = openingHours.filter(
              (hour) => hour.week_day === day
            );

            if (isOpenDay && matchingHours.length > 0) {
              return matchingHours.map((hour, idx) => (
                <p key={`${day}-${idx}`} className="flex">
                  <span style={{ width: "100px" }}>{hour.week_day}</span>
                  <span>
                    {safeFormatTime(hour.opening_time)} -{" "}
                    {safeFormatTime(hour.closing_time)}
                  </span>
                </p>
              ));
            }

            return (
              <p key={day} className="flex">
                <span style={{ width: "100px" }}>{day}</span>
                <span>Closed</span>
              </p>
            );
          })}
        </div>
      </div>
    </details>
  );
}

export function BookingPolicy({ triggerType = "button" }) {
  const [open, setOpen] = useState(false);
  const {
    businessData: { businessData },
  } = useBusinessContext();

  return (
    <>
      {triggerType === "button" ? (
        <button
          className="flex co_pink booking-policy-trigger"
          onClick={() => setOpen(true)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.25 3.625H3.75C3.41848 3.625 3.10054 3.7567 2.86612 3.99112C2.6317 4.22554 2.5 4.54348 2.5 4.875V9.25C2.5 13.3687 4.49375 15.8648 6.16641 17.2336C7.96797 18.707 9.76016 19.207 9.83828 19.2281C9.9457 19.2573 10.059 19.2573 10.1664 19.2281C10.2445 19.207 12.0344 18.707 13.8383 17.2336C15.5063 15.8648 17.5 13.3687 17.5 9.25V4.875C17.5 4.54348 17.3683 4.22554 17.1339 3.99112C16.8995 3.7567 16.5815 3.625 16.25 3.625ZM16.25 9.25C16.25 12.1461 15.1828 14.4969 13.0781 16.2359C12.1619 16.9904 11.12 17.5775 10 17.9703C8.89469 17.5843 7.86558 17.0077 6.95938 16.2664C4.82969 14.5242 3.75 12.1641 3.75 9.25V4.875H16.25V9.25ZM6.43281 11.5672C6.31554 11.4499 6.24965 11.2909 6.24965 11.125C6.24965 10.9591 6.31554 10.8001 6.43281 10.6828C6.55009 10.5655 6.70915 10.4997 6.875 10.4997C7.04085 10.4997 7.19991 10.5655 7.31719 10.6828L8.75 12.1164L12.6828 8.18281C12.7409 8.12474 12.8098 8.07868 12.8857 8.04725C12.9616 8.01583 13.0429 7.99965 13.125 7.99965C13.2071 7.99965 13.2884 8.01583 13.3643 8.04725C13.4402 8.07868 13.5091 8.12474 13.5672 8.18281C13.6253 8.24088 13.6713 8.30982 13.7027 8.38569C13.7342 8.46156 13.7503 8.54288 13.7503 8.625C13.7503 8.70712 13.7342 8.78844 13.7027 8.86431C13.6713 8.94018 13.6253 9.00912 13.5672 9.06719L9.19219 13.4422C9.13414 13.5003 9.06521 13.5464 8.98934 13.5778C8.91346 13.6093 8.83213 13.6255 8.75 13.6255C8.66787 13.6255 8.58654 13.6093 8.51066 13.5778C8.43479 13.5464 8.36586 13.5003 8.30781 13.4422L6.43281 11.5672Z"
              fill="#E40587"
            />
          </svg>
          Booking Policy
        </button>
      ) : (
        <span
          className="booking-policy-text-trigger"
          onClick={() => setOpen(true)}
        >
          booking policy
        </span>
      )}

      {open && (
        <div
          className="booking-policy-modal-overlay"
          onClick={() => setOpen(false)}
        >
          <div
            className="booking-policy-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>Read our booking policy</h2>
              <p className="subtitle">
                A few things you need to know before you book our services
              </p>
            </div>
            <div className="policy-content">
              {businessData?.policy ? (
                <div
                  className="policy-html"
                  dangerouslySetInnerHTML={{ __html: businessData.policy }}
                />
              ) : (
                <p>N/A</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                className="modal-close-btn"
                onClick={() => setOpen(false)}
              >
                Okay
              </button>
            </div>
          </div>

          {/* Overlay background */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.18)",
              zIndex: 1000,
            }}
          />
        </div>
      )}
    </>
  );
}
